import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalUnitSearchParamsModel } from '@apps-common/types/management/unit'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_PORTAL_SEARCH_UNITS = (params?: IPortalUnitSearchParamsModel) =>
  [
    'searchPortalUnits',
    params?.status,
    params?.mCentreId,
    params?.bureauId,
    params?.techCompanyId,
    params?.networkType,
    params?.site,
    params?.accountNo,
    params?.mobileNo,
    params?.imei,
    params?.isActivated,
    params?.pinnedUnits,
    params?.orderBy,
    params?.skip,
    params?.take,
    params?.hasNoActivation
  ].filter(Boolean)

export const searchUnits = async (params: IPortalUnitSearchParamsModel): Promise<IPortalUnitSearchModel[]> =>
  axios.post(`/Unit/SearchUnits`, params).then((res) => res.data?.data)

type QueryFnType = typeof searchUnits

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IPortalUnitSearchParamsModel
}

export const usePortalSearchUnits = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS(model),
    queryFn: () => searchUnits(model)
  })
